import { UntypedFormGroup } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-select-indicativo',
  templateUrl: './select-indicativo.component.html',
  styleUrls: ['./select-indicativo.component.scss']
})
export class SelectIndicativoComponent implements OnInit {

  @Input() indicativoForm: UntypedFormGroup;
  @Input() nombreCampo: string;

  public indicativos = [
    { pais: "Afganistán", indicativo: "+93" },
    { pais: "Albania", indicativo: "+355" },
    { pais: "Alemania", indicativo: "+49" },
    { pais: "Andorra", indicativo: "+376" },
    { pais: "Angola", indicativo: "+244" },
    { pais: "Anguila", indicativo: "+1264" },
    { pais: "Antártida", indicativo: "+672" },
    { pais: "Antigua y Barbuda", indicativo: "+1268" },
    { pais: "Arabia Saudita", indicativo: "+966" },
    { pais: "Argelia", indicativo: "+213" },
    { pais: "Argentina", indicativo: "+54" },
    { pais: "Armenia", indicativo: "+374" },
    { pais: "Aruba", indicativo: "+297" },
    { pais: "Australia", indicativo: "+61" },
    { pais: "Austria", indicativo: "+43" },
    { pais: "Azerbaiyán", indicativo: "+994" },
    { pais: "Bélgica", indicativo: "+32" },
    { pais: "Bahamas", indicativo: "+1242" },
    { pais: "Bahrein", indicativo: "+973" },
    { pais: "Bangladesh", indicativo: "+880" },
    { pais: "Barbados", indicativo: "+1246" },
    { pais: "Belice", indicativo: "+501" },
    { pais: "Bení­n", indicativo: "+229" },
    { pais: "Bhután", indicativo: "+975" },
    { pais: "Bielorrusia", indicativo: "+375" },
    { pais: "Birmania", indicativo: "+95" },
    { pais: "Bolivia", indicativo: "+591" },
    { pais: "Bosnia y Herzegovina", indicativo: "+387" },
    { pais: "Botsuana", indicativo: "+267" },
    { pais: "Brasil", indicativo: "+55" },
    { pais: "Brunéi", indicativo: "+673" },
    { pais: "Bulgaria", indicativo: "+359" },
    { pais: "Burkina Faso", indicativo: "+226" },
    { pais: "Burundi", indicativo: "+257" },
    { pais: "Cabo Verde", indicativo: "+238" },
    { pais: "Camboya", indicativo: "+855" },
    { pais: "Camerún", indicativo: "+237" },
    { pais: "Canadá", indicativo: "+1" },
    { pais: "Chad", indicativo: "+235" },
    { pais: "Chile", indicativo: "+56" },
    { pais: "China", indicativo: "+86" },
    { pais: "Chipre", indicativo: "+357" },
    { pais: "Ciudad del Vaticano", indicativo: "+39" },
    { pais: "Colombia", indicativo: "+57" },
    { pais: "Comoras", indicativo: "+269" },
    { pais: "República del Congo", indicativo: "+242" },
    { pais: "República Democrática del Congo", indicativo: "+243" },
    { pais: "Corea del Norte", indicativo: "+850" },
    { pais: "Corea del Sur", indicativo: "+82" },
    { pais: "Costa de Marfil", indicativo: "+225" },
    { pais: "Costa Rica", indicativo: "+506" },
    { pais: "Croacia", indicativo: "+385" },
    { pais: "Cuba", indicativo: "+53" },
    { pais: "Curazao", indicativo: "+5999" },
    { pais: "Dinamarca", indicativo: "+45" },
    { pais: "Dominica", indicativo: "+1767" },
    { pais: "Ecuador", indicativo: "+593" },
    { pais: "Egipto", indicativo: "+20" },
    { pais: "El Salvador", indicativo: "+503" },
    { pais: "Emiratos Árabes Unidos", indicativo: "+971" },
    { pais: "Eritrea", indicativo: "+291" },
    { pais: "Eslovaquia", indicativo: "+421" },
    { pais: "Eslovenia", indicativo: "+386" },
    { pais: "España", indicativo: "+34" },
    { pais: "Estados Unidos de América", indicativo: "+1" },
    { pais: "Estonia", indicativo: "+372" },
    { pais: "Etiopí­a", indicativo: "+251" },
    { pais: "Filipinas", indicativo: "+63" },
    { pais: "Finlandia", indicativo: "+358" },
    { pais: "Fiyi", indicativo: "+679" },
    { pais: "Francia", indicativo: "+33" },
    { pais: "Gabón", indicativo: "+241" },
    { pais: "Gambia", indicativo: "+220" },
    { pais: "Georgia", indicativo: "+995" },
    { pais: "Ghana", indicativo: "+233" },
    { pais: "Gibraltar", indicativo: "+350" },
    { pais: "Granada", indicativo: "+1473" },
    { pais: "Grecia", indicativo: "+30" },
    { pais: "Groenlandia", indicativo: "+299" },
    { pais: "Guadalupe", indicativo: "+590" },
    { pais: "Guam", indicativo: "+1671" },
    { pais: "Guatemala", indicativo: "+502" },
    { pais: "Guayana Francesa", indicativo: "+594" },
    { pais: "Guernsey", indicativo: "+44" },
    { pais: "Guinea", indicativo: "+224" },
    { pais: "Guinea Ecuatorial", indicativo: "+240" },
    { pais: "Guinea-Bissau", indicativo: "+245" },
    { pais: "Guyana", indicativo: "+592" },
    { pais: "Haití­", indicativo: "+509" },
    { pais: "Honduras", indicativo: "+504" },
    { pais: "Hong kong", indicativo: "+852" },
    { pais: "Hungrí­a", indicativo: "+36" },
    { pais: "India", indicativo: "+91" },
    { pais: "Indonesia", indicativo: "+62" },
    { pais: "Irán", indicativo: "+98" },
    { pais: "Irak", indicativo: "+964" },
    { pais: "Irlanda", indicativo: "+353" },
    { pais: "Isla de Man", indicativo: "+44" },
    { pais: "Isla de Navidad", indicativo: "+61" },
    { pais: "Isla Norfolk", indicativo: "+672" },
    { pais: "Islandia", indicativo: "+354" },
    { pais: "Islas Bermudas", indicativo: "+1441" },
    { pais: "Islas Caimán", indicativo: "+1345" },
    { pais: "Islas Cocos (Keeling)", indicativo: "+61" },
    { pais: "Islas Cook", indicativo: "+682" },
    { pais: "Islas Feroe", indicativo: "+298" },
    { pais: "Islas Georgias del Sur y Sandwich del Sur", indicativo: "+500" },
    { pais: "Islas Maldivas", indicativo: "+960" },
    { pais: "Islas Malvinas", indicativo: "+500" },
    { pais: "Islas Marianas del Norte", indicativo: "+1670" },
    { pais: "Islas Marshall", indicativo: "+692" },
    { pais: "Islas Pitcairn", indicativo: "+870" },
    { pais: "Islas Salomón", indicativo: "+677" },
    { pais: "Islas Turcas y Caicos", indicativo: "+1649" },
    { pais: "Islas Ultramarinas Menores de Estados Unidos", indicativo: "+246" },
    { pais: "Islas Ví­rgenes Británicas", indicativo: "+1284" },
    { pais: "Islas Ví­rgenes de los Estados Unidos", indicativo: "+1340" },
    { pais: "Israel", indicativo: "+972" },
    { pais: "Italia", indicativo: "+39" },
    { pais: "Jamaica", indicativo: "+1876" },
    { pais: "Japón", indicativo: "+81" },
    { pais: "Jersey", indicativo: "+44" },
    { pais: "Jordania", indicativo: "+962" },
    { pais: "Kazajistán", indicativo: "+7" },
    { pais: "Kenia", indicativo: "+254" },
    { pais: "Kirguistán", indicativo: "+996" },
    { pais: "Kiribati", indicativo: "+686" },
    { pais: "Kuwait", indicativo: "+965" },
    { pais: "Lí­bano", indicativo: "+961" },
    { pais: "Laos", indicativo: "+856" },
    { pais: "Lesoto", indicativo: "+266" },
    { pais: "Letonia", indicativo: "+371" },
    { pais: "Liberia", indicativo: "+231" },
    { pais: "Libia", indicativo: "+218" },
    { pais: "Liechtenstein", indicativo: "+423" },
    { pais: "Lituania", indicativo: "+370" },
    { pais: "Luxemburgo", indicativo: "+352" },
    { pais: "México", indicativo: "+52" },
    { pais: "Mónaco", indicativo: "+377" },
    { pais: "Macao", indicativo: "+853" },
    { pais: "Macedí´nia", indicativo: "+389" },
    { pais: "Madagascar", indicativo: "+261" },
    { pais: "Malasia", indicativo: "+60" },
    { pais: "Malawi", indicativo: "+265" },
    { pais: "Mali", indicativo: "+223" },
    { pais: "Malta", indicativo: "+356" },
    { pais: "Marruecos", indicativo: "+212" },
    { pais: "Martinica", indicativo: "+596" },
    { pais: "Mauricio", indicativo: "+230" },
    { pais: "Mauritania", indicativo: "+222" },
    { pais: "Mayotte", indicativo: "+262" },
    { pais: "Micronesia", indicativo: "+691" },
    { pais: "Moldavia", indicativo: "+373" },
    { pais: "Mongolia", indicativo: "+976" },
    { pais: "Montenegro", indicativo: "+382" },
    { pais: "Montserrat", indicativo: "+1664" },
    { pais: "Mozambique", indicativo: "+258" },
    { pais: "Namibia", indicativo: "+264" },
    { pais: "Nauru", indicativo: "+674" },
    { pais: "Nepal", indicativo: "+977" },
    { pais: "Nicaragua", indicativo: "+505" },
    { pais: "Niger", indicativo: "+227" },
    { pais: "Nigeria", indicativo: "+234" },
    { pais: "Niue", indicativo: "+683" },
    { pais: "Noruega", indicativo: "+47" },
    { pais: "Nueva Caledonia", indicativo: "+687" },
    { pais: "Nueva Zelanda", indicativo: "+64" },
    { pais: "Omán", indicativo: "+968" },
    { pais: "Paí­ses Bajos", indicativo: "+31" },
    { pais: "Pakistán", indicativo: "+92" },
    { pais: "Palau", indicativo: "+680" },
    { pais: "Palestina", indicativo: "+970" },
    { pais: "Panamá", indicativo: "+507" },
    { pais: "Papúa Nueva Guinea", indicativo: "+675" },
    { pais: "Paraguay", indicativo: "+595" },
    { pais: "Perú", indicativo: "+51" },
    { pais: "Polinesia Francesa", indicativo: "+689" },
    { pais: "Polonia", indicativo: "+48" },
    { pais: "Portugal", indicativo: "+351" },
    { pais: "Puerto Rico", indicativo: "+1" },
    { pais: "Qatar", indicativo: "+974" },
    { pais: "Reino Unido", indicativo: "+44" },
    { pais: "República Centroafricana", indicativo: "+236" },
    { pais: "República Checa", indicativo: "+420" },
    { pais: "República Dominicana", indicativo: "+1809" },
    { pais: "República de Sudán del Sur", indicativo: "+211" },
    { pais: "Reunión", indicativo: "+262" },
    { pais: "Ruanda", indicativo: "+250" },
    { pais: "Rumaní­a", indicativo: "+40" },
    { pais: "Rusia", indicativo: "+7" },
    { pais: "Sahara Occidental", indicativo: "+212" },
    { pais: "Samoa", indicativo: "+685" },
    { pais: "Samoa Americana", indicativo: "+1684" },
    { pais: "San Bartolomé", indicativo: "+590" },
    { pais: "San Cristóbal y Nieves", indicativo: "+1869" },
    { pais: "San Marino", indicativo: "+378" },
    { pais: "San Martí­n (Francia)", indicativo: "+1599" },
    { pais: "San Pedro y Miquelón", indicativo: "+508" },
    { pais: "San Vicente y las Granadinas", indicativo: "+1784" },
    { pais: "Santa Elena", indicativo: "+290" },
    { pais: "Santa Lucí­a", indicativo: "+1758" },
    { pais: "Santo Tomé y Prí­ncipe", indicativo: "+239" },
    { pais: "Senegal", indicativo: "+221" },
    { pais: "Serbia", indicativo: "+381" },
    { pais: "Seychelles", indicativo: "+248" },
    { pais: "Sierra Leona", indicativo: "+232" },
    { pais: "Singapur", indicativo: "+65" },
    { pais: "Sint Maarten", indicativo: "+1721" },
    { pais: "Siria", indicativo: "+963" },
    { pais: "Somalia", indicativo: "+252" },
    { pais: "Sri lanka", indicativo: "+94" },
    { pais: "Sudáfrica", indicativo: "+27" },
    { pais: "Sudán", indicativo: "+249" },
    { pais: "Suecia", indicativo: "+46" },
    { pais: "Suiza", indicativo: "+41" },
    { pais: "Surinám", indicativo: "+597" },
    { pais: "Svalbard y Jan Mayen", indicativo: "+47" },
    { pais: "Swazilandia", indicativo: "+268" },
    { pais: "Tayikistán", indicativo: "+992" },
    { pais: "Tailandia", indicativo: "+66" },
    { pais: "Taiwán", indicativo: "+886" },
    { pais: "Tanzania", indicativo: "+255" },
    { pais: "Territorio Británico del Océano índico", indicativo: "+246" },
    { pais: "Timor Oriental", indicativo: "+670" },
    { pais: "Togo", indicativo: "+228" },
    { pais: "Tokelau", indicativo: "+690" },
    { pais: "Tonga", indicativo: "+676" },
    { pais: "Trinidad y Tobago", indicativo: "+1868" },
    { pais: "Tunez", indicativo: "+216" },
    { pais: "Turkmenistán", indicativo: "+993" },
    { pais: "Turquí­a", indicativo: "+90" },
    { pais: "Tuvalu", indicativo: "+688" },
    { pais: "Ucrania", indicativo: "+380" },
    { pais: "Uganda", indicativo: "+256" },
    { pais: "Uruguay", indicativo: "+598" },
    { pais: "Uzbekistán", indicativo: "+998" },
    { pais: "Vanuatu", indicativo: "+678" },
    { pais: "Venezuela", indicativo: "+58" },
    { pais: "Vietnam", indicativo: "+84" },
    { pais: "Wallis y Futuna", indicativo: "+681" },
    { pais: "Yemen", indicativo: "+967" },
    { pais: "Yibuti", indicativo: "+253" },
    { pais: "Zambia", indicativo: "+260" },
    { pais: "Zimbabue", indicativo: "+263"}
  ];

  constructor() { 
    this.indicativos = this.indicativos.sort((a, b) => (a.pais.localeCompare(b.pais)))
   }

  ngOnInit(): void {
  }

  get indicative() {
    return this.indicativoForm.get(this.nombreCampo);
  }
}
